document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth > 749) return;

  const galleries = document.querySelectorAll('.custom-product-gallery');

  galleries.forEach((gallery) => {

    const slider = gallery.querySelector('.custom-gallery-slider');
    const progressFill = gallery.querySelector('.mobile-progress-fill');

    if (!slider || !progressFill) return;

    const slides = slider.querySelectorAll('.custom-gallery-slide');
    const totalSlides = slides.length;

   function updateProgress() {
  const slideWidth = slider.offsetWidth;
  const segmentWidth = 100 / totalSlides;

  let index = Math.round(slider.scrollLeft / slideWidth);
  if (index < 0) index = 0;
  if (index > totalSlides - 1) index = totalSlides - 1;

  const fillStart = index * segmentWidth;
  const fillEnd = fillStart + segmentWidth;

  progressFill.style.left = fillStart + '%';
  progressFill.style.width = segmentWidth + '%';
}

    slider.addEventListener('scroll', () => {
      requestAnimationFrame(updateProgress);
    });

    updateProgress();

  });

});